<template>
  <div>
    <header class="app-header">
      <div class="header-background"></div>
      <div class="header-overlay"></div>

      <div class="header-content">
        <!-- Logo and Title - Perfectly Centered -->
        <div class="header-center">
          <div class="logo-container">
            <div class="logo-badge">
              <img class="logo-image" src="/imgs/lgupalompon.png" alt="Palompon Logo" />
              <div class="pulse-ring"></div>
            </div>
          </div>

          <div class="title-section">
            <h1 class="main-title">
              <span class="title-line">Emergency</span>
              <span class="title-line highlight">Response System</span>
            </h1>
            <div class="location-info">
              <i class="bi bi-geo-alt-fill"></i>
              <span>Palompon, Leyte</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script setup>
// No need for status props anymore
</script>

<style scoped>
/* Header Base Styles */
.app-header {
  background: linear-gradient(135deg, var(--dark-bg) 0%, #1c1c1c 100%);
  color: var(--text-primary, #fafafa);
  padding: 1.5rem 2rem;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(220, 38, 38, 0.3);
  backdrop-filter: blur(10px);
  width: 100%;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      ellipse at center,
      rgba(220, 38, 38, 0.15) 0%,
      transparent 70%
    ),
    radial-gradient(ellipse at top left, rgba(220, 38, 38, 0.1) 0%, transparent 50%);
  z-index: 1;
}

.header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(99, 98, 98, 0.95) 0%,
    rgba(49, 48, 48, 0.98) 100%
  );
  z-index: 2;
}

.header-content {
  position: relative;
  z-index: 3;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/* Centered Header Content */
.header-center {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.logo-container {
  position: relative;
}

.logo-badge {
  width: 70px;
  height: 70px;
  background: rgba(220, 38, 38, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 2px solid rgba(220, 38, 38, 0.3);
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
}

.logo-badge:hover {
  border-color: rgba(220, 38, 38, 0.5);
  transform: scale(1.05);
}

.logo-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.pulse-ring {
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid rgba(220, 38, 38, 0.4);
  border-radius: 50%;
  animation: headerPulse 3s ease-in-out infinite;
}

@keyframes headerPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
}

/* Title Section */
.title-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

.main-title {
  margin: 0;
  line-height: 1.2;
  font-weight: 700;
}

.title-line {
  display: block;
  font-size: 1.8rem;
  letter-spacing: -0.5px;
}

.title-line.highlight {
  background: linear-gradient(
    135deg,
    var(--primary-red, #dc2626),
    var(--primary-red-light, #ef4444)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
}

.location-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary, #a3a3a3);
  font-size: 0.9rem;
  font-weight: 500;
}

.location-info i {
  color: var(--primary-red, #dc2626);
  font-size: 0.8rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-header {
    padding: 1rem 1.5rem;
  }

  .header-center {
    flex-direction: column;
    gap: 1rem;
  }

  .title-line {
    font-size: 1.5rem;
  }

  .logo-badge {
    width: 60px;
    height: 60px;
  }

  .logo-image {
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 480px) {
  .app-header {
    padding: 0.8rem 1rem;
  }

  .title-line {
    font-size: 1.3rem;
  }

  .location-info {
    font-size: 0.8rem;
  }
}

/* Fallback variables in case your root isn't loading */
:root {
  --primary-red: #dc2626;
  --primary-red-light: #ef4444;
  --dark-bg: #0a0a0a;
  --text-primary: #fafafa;
  --text-secondary: #a3a3a3;
}
</style>
